import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api, ErrorApi } from '../api/cliente.js';

/**
 * Descarga del trabajador por enlace seguro (HU-06): validación liviana con
 * DNI, con expiración y bloqueo por intentos. El enlace llega por email; el
 * PDF no viaja adjunto.
 */
export function Descarga() {
  const { token } = useParams();
  const [estado, setEstado] = useState<{ vigente: boolean; motivo?: string } | null>(null);
  const [dni, setDni] = useState('');
  const [error, setError] = useState('');
  const [descargando, setDescargando] = useState(false);
  const [listo, setListo] = useState(false);

  useEffect(() => {
    api.publico
      .get<{ vigente: boolean; motivo?: string }>(`/api/descargas/${token}`)
      .then(setEstado)
      .catch((err) => setError(err instanceof ErrorApi ? err.message : String(err)));
  }, [token]);

  async function descargar(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setDescargando(true);
    try {
      const res = await fetch(`/api/descargas/${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ dni }),
      });
      if (!res.ok) {
        const d = (await res.json().catch(() => null)) as { mensaje?: string } | null;
        throw new ErrorApi(res.status, 'DESCARGA', d?.mensaje ?? `Error ${res.status}`);
      }
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `constancia-${token?.slice(0, 6)}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
      setListo(true);
    } catch (err) {
      setError(err instanceof ErrorApi ? err.message : String(err));
    } finally {
      setDescargando(false);
    }
  }

  return (
    <div className="web" style={{ maxWidth: 460 }}>
      <p><Link to="/">← Inicio</Link></p>
      <h1>Tu constancia médica</h1>

      {estado && !estado.vigente && <div className="error-box">{estado.motivo}</div>}

      {estado?.vigente && (
        <div className="tarjeta" style={{ padding: 20 }}>
          <p className="muted">Para descargar tu copia, confirmá tu DNI (validación de seguridad del enlace).</p>
          <form onSubmit={descargar}>
            <div className="campo">
              <label>DNI (sin puntos)</label>
              <input inputMode="numeric" value={dni} onChange={(e) => setDni(e.target.value.replace(/\D/g, ''))} placeholder="30123456" />
            </div>
            {error && <div className="error-box">{error}</div>}
            {listo && <div className="aviso-info"><span>✅</span><span>Descarga iniciada. Revisá tu carpeta de descargas.</span></div>}
            <button className="primario" disabled={descargando || dni.length < 7}>
              {descargando ? 'Verificando…' : 'Descargar PDF'}
            </button>
          </form>
        </div>
      )}

      {!estado && !error && <div className="cargando">Cargando…</div>}

      <p className="disclaimer">
        Tu copia queda disponible a demanda: es un derecho del paciente (Ley 26.529). Si el enlace expiró, podés pedir el
        reenvío. Tras varios intentos con DNI incorrecto, el enlace se bloquea.
      </p>
    </div>
  );
}
